import AdministrationEntries from "../docs-archive-elements/AdministrationEntries";

export default function AdministrationDetails () {
        return (
        <div>

<div className="government-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Administration</h2>
</div>

{/* Start Main Content */}
<div className="content-fluid">
    <div className="mb-960-center-container mid-side-outlines mobile-pad-1em">
        {/* Full Width Element */}
        <div className="mb-960-col-50p">
            <h4>Borough Manager</h4>
            <p>
                The Borough Manager is the Chief Administrative Officer of the Borough Government and is responsible for managing the day-to-day operations of the Borough. The Borough Manager is appointed by the Borough Council and is responsible for the proper administration of the affairs of the Borough.</p>
            <p>
                The Borough Manager implements all policies, ordinances, resolutions, and other official directives of the Borough Council. The Borough Manager supervises the work of various boards, departments, personnel, and outside professionals. The Borough Manager is responsible for the budget, capital improvement projects, strategic planning, and grants.
            </p>
        </div>

        <div className="mb-960-col-50p">
            <h4>Related Files</h4>
           <AdministrationEntries />
        </div>
    </div>
</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>


</div>
</div>
)
}
